import { themeAtom } from "../../shared/atoms";
import StarRating from "./StarRating/StarRating";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

interface RatingRowProps {
  title?: string;
  subtitle?: string;
  rating?: number;
  error?: string;
  onClick?: (starIndex: number) => void;
  className?: string;
  showStarCount?: boolean;
  isVertical?: boolean;
  starFillColor?: string;
  readonly?: boolean;
}

const RatingRow: React.FC<RatingRowProps> = ({
  title,
  subtitle,
  rating,
  error,
  onClick,
  className,
  showStarCount = true,
  isVertical = false,
  starFillColor,
  readonly,
}) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className={twMerge("flex items-center", !isVertical && "gap-[56px]", className)}>
      <div className={twMerge("flex flex-col")}>
        {title && <p className={twMerge("text-[16px] font-bold", theme.vesselDetails.infoText)}>{title}</p>}
        {subtitle && <p className={twMerge("text-sm", theme.vesselDetails.infoText)}>{subtitle}</p>}
      </div>

      <div className="min-w-[246px]">
        <StarRating
          stars={rating ?? 0}
          error={error}
          onClick={onClick}
          showStarCount={showStarCount}
          starFillColor={starFillColor}
          starSize={20}
          starGap="gap-1"
          readonly={readonly}
        />
      </div>
    </div>
  );
};

export default RatingRow;
